/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteFinancialProfileAppRequest} from '@cash-web/protos/squareup/cash/kgoosememorystore/api/v1beta1/app_service.pb'
import {DeleteFinancialProfileAppResponse} from '@cash-web/protos/squareup/cash/kgoosememorystore/api/v1beta1/app_service.pb'


export const deleteFinancialProfileApp = (request: DeleteFinancialProfileAppRequest, options?: CashRequestOptions) => post<DeleteFinancialProfileAppRequest, DeleteFinancialProfileAppResponse>("/2.0/cash/delete-financial-profile-app", request, {...options, rejectOnError: true })